import PreviewBanner from './preview-banner';

export default PreviewBanner;
